import { exists } from '@/api'

export interface LendOutReceiptInfo {
  receiptInfo: any
  receiptAddresseeInfo: any
  receiptUserDueDateNoticeInfo: any
}

export const defaultLendReceiptInfo = (): LendOutReceiptInfo => ({
  receiptInfo: undefined,
  receiptAddresseeInfo: undefined,
  receiptUserDueDateNoticeInfo: undefined
})

export function LendOutReceiptInfoFromJSON(json: any): LendOutReceiptInfo {
  return {
    receiptInfo: exists(json, 'receipt_info') ? json.receipt_info : undefined,
    receiptAddresseeInfo: exists(json, 'receipt_addressee_info')
      ? json.receipt_addressee_info
      : undefined,
    receiptUserDueDateNoticeInfo: exists(
      json,
      'receipt_user_due_date_notice_info'
    )
      ? json.receipt_user_due_date_notice_info
      : undefined
  }
}
